export interface GeoLocationDto {
  ownerUuid?: string;

  latitude: number;

  longitude: number;
}

export const GEOLOCATION_STORAGE_KEY = "geolocation";
